import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';
import { getCookieChoice, setCookieChoice } from '../utils/cookieConsent';

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = getCookieChoice();
    if (!consent) {
      // Show banner after a short delay (cleared on unmount — review §9 #13)
      const t = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(t);
    }
    return undefined;
  }, []);

  const handleAccept = () => {
    setCookieChoice('accepted');
    setShowBanner(false);
  };

  const handleReject = () => {
    // Real now: denies Google Analytics and Google Ads storage on this page
    // and, via public/index.html, on every later visit. It used to do nothing.
    setCookieChoice('rejected');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-content">
          <div className="cookie-icon">🍪</div>
          <div className="cookie-text">
            <h3>Cookie Notice</h3>
            <p>
              We use cookies to keep you signed in and protect our forms from spam, and, if you
              allow it, Google Analytics and Google Ads cookies to measure traffic and ad results.
            </p>
            <p className="cookie-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              {' • '}
              <Link to="/cookie-policy">Cookie Policy</Link>
            </p>
          </div>
        </div>
        
        <div className="cookie-actions">
          <button 
            className="cookie-btn cookie-reject" 
            onClick={handleReject}
            aria-label="Decline analytics and ads cookies"
          >
            Decline analytics &amp; ads
          </button>
          <button 
            className="cookie-btn cookie-accept" 
            onClick={handleAccept}
            aria-label="Accept analytics and ads cookies"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
